import { useEffect, useState } from "react";
import { getSharedPropertiesAsync } from "../taskpane";
import { useReadingEmail } from "./useReadingEmail";
import { useParams } from "react-router-dom";

export const useIsInSharedInbox = () => {
  const { emailId } = useParams<{ emailId: string }>();
  const { emailId: readingEmailId } = useReadingEmail();
  const [isInSharedInbox, setIsInSharedInbox] = useState(false);

  useEffect(() => {
    getSharedPropertiesAsync()
      .then((data) => {
        setIsInSharedInbox(!!data?.value);
      })
      .catch(() => {
        setIsInSharedInbox(false);
      });
  }, [readingEmailId]);

  // If user click mention notification, assume it's in shared inbox
  if (!!emailId && emailId !== readingEmailId) return true;

  return isInSharedInbox;
};
